import ApplicationController from './application_controller'

const models = ['Toyota GR86', 'Subaru BRZ', 'Toyota 86', 'Scion FR-S']

export default class extends ApplicationController {
  static targets = ['cursor', 'output']

  jitter(value, varyByPercent = 0.2) {
    const variation = value * varyByPercent
    const randomVariation = Math.random() * variation * 2 - variation
    return value + randomVariation
  }

  async *generateStrings() {
    while (true) {
      for (const model of models) {
        let s = ''

        // print the model name
        for (const char in model) {
          if (char !== ' ') {
            await this.sleep(this.jitter(100))
          }
          s += model[char]
          yield s
        }

        // pause after rendering the full name
        await this.sleep(this.jitter(1500))

        // erase the model name
        for (const _ in model) {
          await this.sleep(this.jitter(50, 0.1))
          s = s.slice(0, -1)
          yield s
        }
        await this.sleep(this.jitter(200))
      }
    }
  }

  async connect() {
    const stream = this.generateStrings()

    this.cursorTarget.textContent = '▋' // add cursor for JS users
    this.outputTarget.textContent = '' // clear the no-JS fallback

    for await (const value of stream) {
      this.outputTarget.textContent = value
    }
  }
}
